module.exports = "<p [innerHTML]=\"data.message\"></p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-error/dialog-error.component.html
// module id = ./src/app/dialog-error/dialog-error.component.html
// module chunks = main